import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import { ViewModelForm } from '@xengage/gw-portals-viewmodel-react';
import metadata from './WMICPolicyPaCommercialDriverComponent.metadata.json5';

import messages from './WMICPolicyPaCommercialDriverComponent.messages.js';
import { WMICRPCUtil } from 'wmic-pe-portals-utils-js';
import { TranslatorContext } from '@jutro/legacy/locale';

function WMICPolicyPaCommercialDriverComponent(props) {
    const { commercialDriverVM, policyVM } = props;

    const translator = useContext(TranslatorContext);

    const isRPC2172Effective = WMICRPCUtil.getIsRPCEffective(
        policyVM?.lobs?.personalAuto?.baseState?.value?.code,
        policyVM?.latestPeriod?.rateAsOfDate?.value,
        '2172'
    );

    const isAuthSectionContainerVisible = !!(commercialDriverVM?.authContainer?.aspects?.ocular && !isRPC2172Effective);

    const isHaulingSectionContainerVisible = !isRPC2172Effective;

    const isHazardSectionContainerVisible = !isRPC2172Effective;

    const isHeavyVehicleExpSectionContainerVisible = !!(
        commercialDriverVM?.heavyVehicleExpContainer?.aspects?.ocular && !isRPC2172Effective
    );

    const overrideProps = {
        '@field': {
            parentNode: commercialDriverVM,
            readOnly: true,
        },
        requiredMsg: {
            content: translator(messages.requiredMsg),
        },
        authSectionContainer: {
            visible: isAuthSectionContainerVisible,
        },
        haulingSectionContainer: {
            visible: isHaulingSectionContainerVisible,
        },
        hazardSectionContainer: {
            visible: isHazardSectionContainerVisible,
        },
        trainingSectionContainer: {
            visible: _.get(commercialDriverVM, 'trainingContainer.aspects.ocular'),
        },
        completedTrainingContainer: {
            visible: _.get(commercialDriverVM, 'completedTrainingContainer.aspects.ocular'),
        },
        heavyVehicleExpSectionContainer: {
            visible: isHeavyVehicleExpSectionContainerVisible,
        },
    };

    return (
        <ViewModelForm uiProps={metadata.componentContent} model={commercialDriverVM} overrideProps={overrideProps} />
    );
}

WMICPolicyPaCommercialDriverComponent.propTypes = {
    commercialDriverVM: PropTypes.shape({}).isRequired,
};

export default WMICPolicyPaCommercialDriverComponent;
